module.exports = __webpack_public_path__ + "static/media/travelers.491361e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/travelers.png
// module id = 84
// module chunks = 0